(function () {
  // Mobile menu
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.getElementById('SiteNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Bespoke form -> WhatsApp message
  document.querySelectorAll('[data-bespoke]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var wa = form.getAttribute('data-wa');
      if (!wa) return;
      var d = form.elements.deity.value;
      var h = form.elements.height.value;
      var date = form.elements.date.value;
      var msg = 'Namaste! I would like a bespoke poshak.\nDeity: ' + d + '\nIdol height: ' + h + ' inches' + (date ? '\nNeeded by: ' + date : '') + '\nI will share a photo of the idol here.';
      window.open('https://wa.me/' + wa + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');
    });
  });

  // Quantity buttons
  document.querySelectorAll('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty'), 10));
      input.value = v;
    });
  });

  // Product: variant picker + gallery
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var json = root.querySelector('[data-variants]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var form = root.querySelector('[data-product-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-add]');
    var main = root.querySelector('[data-main-media]');
    var fmt = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });

    function setMain(src) {
      if (!main || !src) return;
      var img = main.querySelector('img');
      if (!img) return;
      img.removeAttribute('srcset');
      img.src = src;
    }

    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('[data-thumb]').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
        setMain(t.getAttribute('data-src'));
      });
    });

    function selected() {
      var opts = [];
      root.querySelectorAll('input[data-opt]:checked').forEach(function (i) {
        opts[parseInt(i.getAttribute('data-opt'), 10)] = i.value;
        var label = root.querySelector('[data-opt-label="' + i.getAttribute('data-opt') + '"]');
        if (label) label.textContent = i.value;
      });
      return opts;
    }

    function update() {
      var opts = selected();
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return opts[i] === undefined || o === opts[i]; });
      });
      if (!v) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      var html = fmt.format(v.price / 100);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        html += ' <s style="font-size:1rem;font-weight:400;color:#8A6B55;margin-left:8px">' + fmt.format(v.compare_at_price / 100) + '</s>';
      }
      priceEl.innerHTML = html + ' <small style="margin-left:6px">incl. GST</small>';
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (v.featured_image && v.featured_image.src) setMain(v.featured_image.src);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.querySelectorAll('input[data-opt]').forEach(function (i) { i.addEventListener('change', update); });
    if (form) {
      form.addEventListener('submit', function () { addBtn.textContent = 'Adding…'; });
    }
  });

  // Cart: auto-submit on quantity change
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () { input.form.submit(); });
  });
})();
